export const QuestionnaireStepsEnum = {
  OFFICE: "office",
  REQUIREMENTS: "requirements",
  SUMMARY: "summary",
  COMPLETE: "complete",
};
